import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/pt';
import 'moment/locale/de';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useTranslation } from 'react-i18next';
import { ptBR, deDE } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

export default function DateTimeProvider(props) {
  const { children } = props;
  const { i18n } = useTranslation();

  let language = 'en-gb';
  const pt = ptBR.components.MuiLocalizationProvider.defaultProps.localeText;
  const de = deDE.components.MuiLocalizationProvider.defaultProps.localeText;
  let localeText;
  if (i18n.language === 'pt_BR') {
    language = 'pt';
    localeText = pt;
  } else if (i18n.language === 'de_DE') {
    language = 'de';
    localeText = de;
  }

  moment.locale(language);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={language} localeText={localeText}>
      {children}
    </LocalizationProvider>
  );
}

DateTimeProvider.propTypes = {
  children: PropTypes.element.isRequired
};
